(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('DeliveryDetailsController', DeliveryDetailsController);

    DeliveryDetailsController.$inject = ['$q', '$scope', 'Principal', '$state', 'MessageService', 'LocationProvice', '$localStorage', '$uibModalInstance', 'entity','DeliveryRequest','SupplierDeliveryRequest'];

    function DeliveryDetailsController ($q, $scope, Principal, $state, MessageService, LocationProvice, $localStorage, $uibModalInstance, entity,DeliveryRequest,SupplierDeliveryRequest) {
        var vm = this;
        console.log($state);
        if($state.current.name == 'supplierDeliveryRequest'){
            SupplierDeliveryRequest.get({id: entity.id}, function (res) {
                vm.data = res;
            })
        }else{
            DeliveryRequest.get({id: entity.id}, function (res) {
                vm.data = res;
            })
        }
        //取消
        $scope.modalHide = function () {
            $uibModalInstance.close();
        }
    }
})();
